import { requiredStrategy } from '../core';
import { plateNumberFormatStrategy } from './plate-number-format-strategy';

export const plateNumberStrategy = (value: string) => {
  return requiredStrategy(value) && plateNumberFormatStrategy(value);
};
